var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScrapeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    width: "30%",
    height: "30%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.1,26c0-4.3-3.6-7.7-7.9-7.5c-1-2.7-3.5-4.6-6.5-4.6c-0.3,0-0.6,0-0.9,0.1c-0.9-3.7-4.2-6.3-8.1-6.3    c-4.6,0-8.3,3.7-8.3,8.3c0,0.5,0,0.9,0.1,1.4c-4.2,0.3-7.5,3.8-7.5,8c0,2.6,1.2,5,3.1,6.5c0.4,0.3,1.1,0.3,1.4-0.2    c0.3-0.4,0.3-1.1-0.2-1.4c-1.5-1.1-2.3-3-2.3-4.9c0-3.3,2.7-6,6-6c0.2,0,0.5,0,0.7,0l1.6,0.2l-0.5-1.5c-0.2-0.7-0.4-1.4-0.4-2.1    c0-3.5,2.8-6.3,6.3-6.3c3.2,0,5.9,2.4,6.3,5.6l0.1,1.2l1.2-0.4c0.5-0.1,0.9-0.2,1.4-0.2c2.3,0,4.3,1.6,4.8,3.9l0.2,1l1-0.2    c0.4-0.1,0.7-0.1,1-0.1c3,0,5.5,2.5,5.5,5.5c0,2.5-1.3,5.5-4.9,5.5H17.8c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h20.4    C42.2,33.5,45.1,30.4,45.1,26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2,41.5C22.7,41.4,20,41,17.9,39c-2-1.9-3-4.7-3-8.4l-2-0.2c-0.1,0.5-2.4,12.6,2.9,19.1c2,2.4,4.8,3.8,8.3,4v5.1    L37,47.4L24.2,36.2V41.5z M25.2,43.5l0.9-0.1v-2.9l7.8,6.8l-7.8,6.8v-2.7h-1c-3.3,0-5.9-1.1-7.7-3.3c-2.3-2.9-3-7.1-3-10.7    c0.6,1.1,1.3,2.1,2.2,3C20.2,43.8,25,43.5,25.2,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6,42.3C58.6,42.2,58.6,42.2,58.6,42.3c0-0.2-0.1-0.3-0.1-0.4c0,0,0,0,0,0c0,0,0,0,0,0c-0.1-0.1-0.1-0.2-0.2-0.3    c0,0,0,0-0.1-0.1c0,0,0,0-0.1,0l-9.1-5.2c-0.3-0.2-0.7-0.2-1,0L39,41.5c0,0,0,0-0.1,0c0,0,0,0-0.1,0.1c-0.1,0.1-0.2,0.2-0.2,0.3    c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0.1-0.1,0.2-0.1,0.3c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1v10.5c0,0.4,0.2,0.7,0.5,0.9l9.1,5.2    c0.2,0.1,0.3,0.1,0.5,0.1s0.3,0,0.5-0.1l9.1-5.2c0.3-0.2,0.5-0.5,0.5-0.9L58.6,42.3C58.7,42.3,58.6,42.3,58.6,42.3z M48.6,38.3    l7.1,4.1l-7.1,4.1l-7.1-4.1L48.6,38.3z M40.5,44.1l7.1,4.1v8.1l-7.1-4.1V44.1z M49.6,56.3v-8.1l7.1-4.1v8.1L49.6,56.3z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrapeIcon);
export default __webpack_public_path__ + "static/media/scrape-icon.ee2ce9d4.svg";
export { ForwardRef as ReactComponent };